import { render, staticRenderFns } from "./fccAbaMensagem.vue?vue&type=template&id=a5f5912a"
import script from "./fccAbaMensagem.vue?vue&type=script&lang=js"
export * from "./fccAbaMensagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports